// BAT d'exemple pour la démonstration : dépliant A4 roulé en DL (3 volets), dessiné en SVG.
// Imprimerie, client et visuels fictifs.
import type { DocPage } from "./types.ts";

const W = 1600, H = 1131; // A4 à l'italienne
const svg = (body: string) =>
  `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" font-family="Helvetica, Arial, sans-serif">${body}</svg>`)}`;

const M = 70, PW = (W - 2 * M) / 3, PH = H - 2 * M - 70;
const frame = (title: string) => `
  <rect width="${W}" height="${H}" fill="#E9E6DF"/>
  <text x="${M}" y="48" font-size="26" font-weight="700" fill="#1C1F23">BAT · OF-2611 · Dépliant été 3 volets · ${title}</text>
  <text x="${W - M}" y="48" font-size="22" fill="#6B6E73" text-anchor="end">A4 → DL · pli roulé · couché mat 135 g</text>
  <rect x="${M}" y="${M + 10}" width="${W - 2 * M}" height="${PH}" fill="#fff" stroke="#BDB8AE"/>
  ${[1, 2].map((i) => `<line x1="${M + i * PW}" y1="${M}" x2="${M + i * PW}" y2="${M + PH + 20}" stroke="#C2410C" stroke-width="3" stroke-dasharray="14 10"/>
  <text x="${M + i * PW}" y="${M + PH + 52}" font-size="22" fill="#C2410C" text-anchor="middle">pli ${i}</text>`).join("")}`;

const lines = (x: number, y: number, n: number, w: number) =>
  Array.from({ length: n }, (_, i) => `<rect x="${x}" y="${y + i * 30}" width="${i % 4 === 3 ? w * 0.6 : w}" height="12" rx="3" fill="#CFCBC3"/>`).join("");

const recto = svg(`${frame("recto")}
  <g>
    <text x="${M + PW / 2}" y="${M + 80}" font-size="30" font-weight="700" fill="#0F766E" text-anchor="middle">Volet rabattu</text>
    ${lines(M + 50, M + 130, 14, PW - 100)}
  </g>
  <g>
    <text x="${M + PW * 1.5}" y="${M + 80}" font-size="30" font-weight="700" fill="#0F766E" text-anchor="middle">Dos</text>
    <rect x="${M + PW + 60}" y="${M + 130}" width="${PW - 120}" height="220" fill="#DCEFEB"/>
    ${lines(M + PW + 60, M + 390, 8, PW - 120)}
    <text x="${M + PW * 1.5}" y="${M + PH - 40}" font-size="22" fill="#6B6E73" text-anchor="middle">Office de tourisme · adresse · horaires</text>
  </g>
  <g>
    <rect x="${M + 2 * PW}" y="${M + 10}" width="${PW}" height="${PH}" fill="#0F766E"/>
    <circle cx="${M + 2.5 * PW}" cy="${M + 300}" r="110" fill="#F5C542"/>
    <path d="M${M + 2 * PW} ${M + 520} q 60 -40 120 0 t 120 0 t 120 0 t 120 0 t 120 0 V ${M + PH + 10} H ${M + 2 * PW} Z" fill="#1F5FAD"/>
    <text x="${M + 2.5 * PW}" y="${M + 640}" font-size="58" font-weight="800" fill="#fff" text-anchor="middle">Été sur la Côte</text>
    <text x="${M + 2.5 * PW}" y="${M + 700}" font-size="28" fill="#E6F4F2" text-anchor="middle">Balades · marchés · plages</text>
    <text x="${M + 2.5 * PW}" y="${M + 80}" font-size="30" font-weight="700" fill="#fff" text-anchor="middle">Couverture</text>
  </g>
  <g transform="translate(${M + PW * 1.5 - 210}, ${H - 34})">
    <text font-size="24" font-weight="700" fill="#1C1F23">Sens d'ouverture vers la droite →</text>
  </g>`);

const verso = svg(`${frame("verso")}
  ${[0, 1, 2].map((i) => `<g>
    <text x="${M + PW * (i + 0.5)}" y="${M + 80}" font-size="30" font-weight="700" fill="#0F766E" text-anchor="middle">Intérieur ${i + 1}</text>
    <rect x="${M + PW * i + 50}" y="${M + 120}" width="${PW - 100}" height="200" fill="#F3E3C8"/>
    ${lines(M + PW * i + 50, M + 360, 11, PW - 100)}
  </g>`).join("")}`);

export const DEMO_BAT_PAGES: DocPage[] = [
  { data: recto, width: W, height: H },
  { data: verso, width: W, height: H },
];
